import React from 'react';
import PropTypes from 'prop-types';
import CmsContent from '../../CmsContent';
import Message from '../../../../components/message/Message';
import Block from '../../../block/Block';
export var MessageNotification = function MessageNotification(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var text = _ref2$component$conte.text;

  var _ref3 = metadata || {},
      _ref3$messageType = _ref3.messageType;

  _ref3$messageType = _ref3$messageType === void 0 ? {} : _ref3$messageType;
  var messageType = _ref3$messageType.Title;
  return messageType && text ? /*#__PURE__*/React.createElement(Block, {
    "data-en": 'cms-message-notification',
    m: "m"
  }, /*#__PURE__*/React.createElement(Message, {
    level: messageType,
    flex: true,
    basisZero: true,
    filled: false,
    dark: false,
    inline: false
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: text
  }))) : null;
};
MessageNotification.propTypes = {
  data: PropTypes.object.isRequired
};
export default MessageNotification;